'use strict';

var AlertsPanelFaresFilterByMarketFactory = function AlertsPanelFaresFilterByMarketFactory(DataFilter, angularHelper) {
  var filtersNamesList = ['MarketsFilterByMarketFactory', 'SchedulesFilterByMonthsFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function AlertsPanelFaresFilterByMarket() {
    DataFilter.call(this, 'fim-dashboard', 'dashboard-alerts-panel', 2);
    this.registerFilters(injectedFilters);
  }
  AlertsPanelFaresFilterByMarket.prototype = Object.create(DataFilter.prototype);
  return AlertsPanelFaresFilterByMarket;
};
AlertsPanelFaresFilterByMarketFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = AlertsPanelFaresFilterByMarketFactory;